module.exports = __webpack_public_path__ + "img/abehirosuke@2x.3ebdcd6d.png";